(function () {
  // Prevent cart.js initCartShippingProtection from adding the wrong variant first
  window.localStorage.setItem('ecomify-shipping-protection-init', 'true');

  const getConfig = () => document.getElementById('shipping-protection-config');

  const getCart = () =>
    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());

  const isProtectionItem = (item, config) =>
    item.handle === config.dataset.productHandle ||
    (item.product_title && item.product_title.includes('Shipping Protection'));

  const getCartSubtotalExcludingProtection = (cart, config) =>
    cart.items.reduce((total, item) => {
      if (isProtectionItem(item, config)) return total;
      return total + item.final_line_price;
    }, 0);

  const getTargetVariantId = (cart, config) => {
    const threshold = Number(config.dataset.thresholdCents);
    const subtotal = getCartSubtotalExcludingProtection(cart, config);
    return subtotal >= threshold
      ? config.dataset.highVariantId
      : config.dataset.lowVariantId;
  };

  const hasOtherCartItems = (cart, config) =>
    cart.items.some((item) => !isProtectionItem(item, config));

  const updateCheckboxVariant = (variantId, lineItemKey) => {
    const checkbox = document.getElementById('cart-shipping-protection-checkbox');
    if (!checkbox) return;
    checkbox.value = variantId;
    if (lineItemKey) {
      checkbox.setAttribute('data-line-item-key', lineItemKey);
    } else {
      checkbox.removeAttribute('data-line-item-key');
    }
  };

  let initialAutoAddDone = false;
  let userOptedOut = false;

  const setProtectionVisible = (visible) => {
    if (visible) {
      document.body.classList.add('shipping-protection-ready');
    } else {
      document.body.classList.remove('shipping-protection-ready');
    }
  };

  const syncShippingProtection = async ({ allowAutoAdd = false } = {}) => {
    const config = getConfig();
    if (!config || config.dataset.enabled !== 'true') {
      setProtectionVisible(true);
      return;
    }

    if (window.addingShippingProtection || window.removingShippingProtection) return;

    const cart = await getCart();
    const targetVariantId = getTargetVariantId(cart, config);
    const autoAdd = config.dataset.autoAdd === 'true';
    const protectionItems = cart.items.filter((item) => isProtectionItem(item, config));

    if (protectionItems.length > 1) {
      window.removingShippingProtection = true;
      try {
        let lastResponse = null;
        for (let i = 1; i < protectionItems.length; i++) {
          lastResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protectionItems[i].key, quantity: 0 }),
          });
        }
        if (lastResponse && typeof window.refreshCartContents === 'function') {
          await window.refreshCartContents(lastResponse.clone());
        }
      } finally {
        window.removingShippingProtection = false;
      }
      setProtectionVisible(true);
      return;
    }

    const protectionItem = protectionItems[0];
    const needsVariantSwap =
      protectionItem &&
      protectionItem.variant_id.toString() !== targetVariantId.toString();

    if (needsVariantSwap) {
      setProtectionVisible(false);
    }

    if (protectionItem) {
      updateCheckboxVariant(targetVariantId, protectionItem.key);
      const checkbox = document.getElementById('cart-shipping-protection-checkbox');
      if (checkbox) checkbox.checked = true;

      if (needsVariantSwap) {
        window.addingShippingProtection = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protectionItem.key, quantity: 0 }),
          });
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(targetVariantId), quantity: 1 }] }),
          });
          if (typeof window.refreshCartContents === 'function') {
            await window.refreshCartContents(addResponse.clone());
          }
        } finally {
          window.addingShippingProtection = false;
        }
      }
      setProtectionVisible(true);
      return;
    }

    const checkbox = document.getElementById('cart-shipping-protection-checkbox');
    if (checkbox) {
      checkbox.checked = false;
      updateCheckboxVariant(targetVariantId);
    }

    if (
      allowAutoAdd &&
      !initialAutoAddDone &&
      !userOptedOut &&
      autoAdd &&
      hasOtherCartItems(cart, config)
    ) {
      initialAutoAddDone = true;
      window.addingShippingProtection = true;
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(targetVariantId), quantity: 1 }] }),
        });
        if (typeof window.refreshCartContents === 'function') {
          await window.refreshCartContents(addResponse.clone());
        }
      } finally {
        window.addingShippingProtection = false;
      }
    }

    setProtectionVisible(true);
  };

  window.onChangeCartShippingProtection = async (input) => {
    const config = getConfig();
    const cart = await getCart();
    const targetVariantId = config
      ? getTargetVariantId(cart, config)
      : input.value;

    window.removingShippingProtection = !input.checked;

    let response;
    try {
      if (input.checked) {
        userOptedOut = false;
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ quantity: 1, id: Number(targetVariantId) }] }),
        });
      } else {
        userOptedOut = true;
        response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: input.dataset.lineItemKey, quantity: 0 }),
        });
      }

      if (typeof window.refreshCartContents === 'function') {
        await window.refreshCartContents(response);
      }
    } finally {
      window.removingShippingProtection = false;
    }
  };

  const initRemoveListener = () => {
    document.addEventListener('click', (event) => {
      const removeBtn = event.target.closest('[data-remove-line-item]');
      if (!removeBtn) return;

      const lineItem = removeBtn.closest('.shipping-protection-line-item');
      if (lineItem) {
        userOptedOut = true;
        window.removingShippingProtection = true;
        setTimeout(() => {
          window.removingShippingProtection = false;
        }, 2000);
      }
    });
  };

  const init = () => {
    initRemoveListener();
    syncShippingProtection({ allowAutoAdd: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('updated.ecomify.cart', () => {
    syncShippingProtection({ allowAutoAdd: false });
  });
})();
